import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';

interface BodyProps {
  hasMobileFooterMenu: boolean;
}

export const Body = styled(Row)<BodyProps>`
  position: relative;
  z-index: 0;
  ${({ hasMobileFooterMenu, theme }) =>
    hasMobileFooterMenu &&
    media.mdDown`
      padding-bottom: calc(${theme.x8spacePx}px + ${theme.safeAreaInsetBottom});
    `};
`;
